import React, { useState } from 'react';
import { LegalModal } from './ui/LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const closeModal = () => setActiveModal(null);
  return <footer className="w-full py-12 px-6 bg-night-500 border-t border-night-300 text-center relative z-10" data-id="element-7">
      <div className="max-w-4xl mx-auto space-y-8" data-id="element-8">
        <div className="space-y-4" data-id="element-9">
          <p className="font-serif text-2xl text-night-50" data-id="element-10">
            Dormir 5 Horas Seguidas
          </p>
          <p className="text-night-100 text-sm max-w-lg mx-auto leading-relaxed" data-id="element-11">
            Este producto no sustituye el consejo médico profesional. Siempre
            consulta con tu pediatra antes de realizar cambios significativos en
            la rutina de tu bebé.
          </p>
        </div>

        {/* Legal Links */}
        <div className="flex flex-wrap justify-center gap-6 text-sm text-night-100" data-id="element-12">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-amber-warm underline decoration-night-300 underline-offset-4 transition-colors" data-id="element-13">
            Política de Privacidad
          </button>
          <button onClick={() => setActiveModal('terms')} className="hover:text-amber-warm underline decoration-night-300 underline-offset-4 transition-colors" data-id="element-14">
            Términos y Condiciones
          </button>
        </div>

        <div className="text-night-200 text-xs pt-4 border-t border-night-300/30 w-full max-w-xs mx-auto" data-id="element-15">
          &copy; {new Date().getFullYear()} Todos los derechos reservados.
        </div>
      </div>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" data-id="element-16">
        <div className="space-y-4 text-sm md:text-base" data-id="element-17">
          <p data-id="element-18">
            <strong data-id="element-19">Última actualización: {new Date().getFullYear()}</strong>
          </p>

          <h3 className="text-lg font-serif text-night-50 mt-4" data-id="element-20">
            1. Recopilación de Información
          </h3>
          <p data-id="element-21">
            Solo recopilamos la información necesaria para procesar tu pedido y
            entregarte el producto digital (nombre y correo electrónico). No
            almacenamos datos de tarjetas de crédito; los pagos son procesados
            de forma segura por nuestros proveedores de pago.
          </p>

          <h3 className="text-lg font-serif text-night-50 mt-4" data-id="element-22">
            2. Uso de la Información
          </h3>
          <p data-id="element-23">
            Tu correo electrónico se utiliza exclusivamente para enviarte el
            enlace de descarga del producto, tu recibo de compra y,
            ocasionalmente, actualizaciones relevantes sobre el producto o
            consejos relacionados con el sueño infantil. Puedes darte de baja en
            cualquier momento.
          </p>

          <h3 className="text-lg font-serif text-night-50 mt-4" data-id="element-24">
            3. Protección de Datos
          </h3>
          <p data-id="element-25">
            No vendemos, alquilamos ni compartimos tu información personal con
            terceros para fines comerciales. Implementamos medidas de seguridad
            estándar para proteger tus datos.
          </p>

          <h3 className="text-lg font-serif text-night-50 mt-4" data-id="element-26">4. Cookies</h3>
          <p data-id="element-27">
            Utilizamos cookies esenciales para el funcionamiento del carrito de
            compra y el proceso de pago. Al utilizar nuestro sitio, aceptas el
            uso de estas cookies.
          </p>
        </div>
      </LegalModal>

      {/* Terms of Service Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={closeModal} title="Términos y Condiciones" data-id="element-28">
        <div className="space-y-4 text-sm md:text-base" data-id="element-29">
          <p data-id="element-30">
            <strong data-id="element-31">
              Al adquirir "Dormir 5 Horas Seguidas", aceptas los siguientes
              términos:
            </strong>
          </p>

          <h3 className="text-lg font-serif text-night-50 mt-4" data-id="element-32">
            1. Naturaleza del Producto
          </h3>
          <p data-id="element-33">
            Este es un producto 100% digital (PDF descargable). No se enviará
            ningún producto físico. El acceso al material se otorga
            inmediatamente después de la confirmación del pago.
          </p>

          <h3 className="text-lg font-serif text-night-50 mt-4" data-id="element-34">
            2. Propiedad Intelectual
          </h3>
          <p data-id="element-35">
            El contenido de esta guía está protegido por derechos de autor. Tu
            compra te otorga una licencia personal e intransferible. Queda
            estrictamente prohibida la distribución, reventa o compartición
            pública de este material sin autorización expresa.
          </p>

          <h3 className="text-lg font-serif text-night-50 mt-4" data-id="element-36">
            3. Descargo de Responsabilidad Médica
          </h3>
          <p data-id="element-37">
            El contenido de esta guía es informativo y educativo. No constituye
            consejo médico. No somos médicos ni pediatras. Siempre consulta con
            un profesional de la salud antes de implementar cambios en la
            alimentación o sueño de tu bebé, especialmente si tiene condiciones
            médicas preexistentes.
          </p>

          <h3 className="text-lg font-serif text-night-50 mt-4" data-id="element-38">
            4. Política de Reembolso
          </h3>
          <p data-id="element-39">
            Debido a la naturaleza digital e irrevocable del producto, todas las
            ventas son finales. Sin embargo, si tienes problemas técnicos con la
            descarga, contáctanos para asistirte inmediatamente.
          </p>
        </div>
      </LegalModal>
    </footer>;
}